import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import adminActions from '../../../../actions/adminActions';

const LocationAssignmentsPanel = ({ user, reviewGroupTerritories }) => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const removeLocation = (territoryId) => {
    dispatch(adminActions.unassignTerritories(user.id, [territoryId]));
  };

  const confirmRemoveAllLocations = () => {
    const allTerritoryIds = user.assignedTerritories.map((territory) => territory.id);
    dispatch(adminActions.unassignTerritories(user.id, allTerritoryIds));
    handleCloseDialog();
  };

  const reviewGroupAssignments = user.assignedTerritories?.filter((at) => {
    return reviewGroupTerritories.territories.find((rt) => rt.id === at.id);
  });

  return (
    <Box>
      <Typography variant="h6">Assignments</Typography>
      {reviewGroupAssignments && reviewGroupAssignments.length > 0 && (
        <Button
          variant="contained"
          color="error"
          startIcon={<RemoveCircleOutlineIcon />}
          onClick={handleOpenDialog}
        >
          Unassign All
        </Button>
      )}
      <List>
        {reviewGroupAssignments &&
          reviewGroupAssignments.length > 0 &&
          reviewGroupAssignments
            .filter((at) => {
              return reviewGroupTerritories.territories.find((rt) => rt.id === at.id);
            })
            .map((territory) => (
              <ListItem
                key={territory.id}
                secondaryAction={
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => removeLocation(territory.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
              >
                <ListItemText primary={territory.name} />
              </ListItem>
            ))}
      </List>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Removal'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove all assignments?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={confirmRemoveAllLocations} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

LocationAssignmentsPanel.propTypes = {
  user: PropTypes.object.isRequired,
  reviewGroupTerritories: PropTypes.shape({
    reviewGroupName: PropTypes.string,
    reviewGroupValue: PropTypes.string,
    territories: PropTypes.array,
  }).isRequired,
};

export default LocationAssignmentsPanel;
